"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSetParser = void 0;
const abstract_1 = require("./abstract");
/**
 * @author Kuba Fogel <kuba.fogel@movecloser.pl>
 */
class DataSetParser extends abstract_1.AbstractParser {
    /**
     * Parses the passed-in EmbedToken to HTML.
     *
     * @param src - EmbedToken to parse.
     *
     * @returns - HTML representation of the passed-in EmbedToken.
     */
    parse(src) {
        return '<section class="data-set"></section>';
    }
}
exports.DataSetParser = DataSetParser;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0YS1zZXQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcGFyc2Vycy9kYXRhLXNldC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsK0JBQStCOzs7QUFJL0IseUNBQTJDO0FBRTNDOztHQUVHO0FBQ0gsTUFBYSxhQUFjLFNBQVEseUJBQTRCO0lBQzdEOzs7Ozs7T0FNRztJQUNJLEtBQUssQ0FBRSxHQUFpQjtRQUM3QixPQUFPLHNDQUFzQyxDQUFBO0lBQy9DLENBQUM7Q0FDRjtBQVhELHNDQVdDIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQ29weXJpZ2h0IMKpIDIwMjEgTW92ZSBDbG9zZXJcblxuaW1wb3J0IHsgRGF0YVNldFRva2VuIH0gZnJvbSAnLi4vY29udHJhY3RzJ1xuXG5pbXBvcnQgeyBBYnN0cmFjdFBhcnNlciB9IGZyb20gJy4vYWJzdHJhY3QnXG5cbi8qKlxuICogQGF1dGhvciBLdWJhIEZvZ2VsIDxrdWJhLmZvZ2VsQG1vdmVjbG9zZXIucGw+XG4gKi9cbmV4cG9ydCBjbGFzcyBEYXRhU2V0UGFyc2VyIGV4dGVuZHMgQWJzdHJhY3RQYXJzZXI8RGF0YVNldFRva2VuPiB7XG4gIC8qKlxuICAgKiBQYXJzZXMgdGhlIHBhc3NlZC1pbiBFbWJlZFRva2VuIHRvIEhUTUwuXG4gICAqXG4gICAqIEBwYXJhbSBzcmMgLSBFbWJlZFRva2VuIHRvIHBhcnNlLlxuICAgKlxuICAgKiBAcmV0dXJucyAtIEhUTUwgcmVwcmVzZW50YXRpb24gb2YgdGhlIHBhc3NlZC1pbiBFbWJlZFRva2VuLlxuICAgKi9cbiAgcHVibGljIHBhcnNlIChzcmM6IERhdGFTZXRUb2tlbik6IHN0cmluZyB7XG4gICAgcmV0dXJuICc8c2VjdGlvbiBjbGFzcz1cImRhdGEtc2V0XCI+PC9zZWN0aW9uPidcbiAgfVxufVxuIl19